import React, { FC } from 'react';
import { LabelValue, formatDateString, formatDateTimeString, FormGrid, Widget } from '../../../shared';
import { ListAltTwoTone } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { IShipment } from '../../models';

interface Props {
    shipment: IShipment;
}

export const ShipmentDetailInfo: FC<Props> = ({ shipment }) => {
    const { t } = useTranslation();

    return (
        <Widget title={t('shipment')} icon={<ListAltTwoTone color="primary" />}>
            <FormGrid size={{ xs: 12, md: 4 }}>
                <LabelValue label={t('date')} value={formatDateString(shipment.shipmentDate)} />
                <LabelValue label={t('organisation')} value={shipment.receiver?.name} />
                <LabelValue label={t('sequenceNumber')} value={shipment.sequenceNumber.toString()} />
                <LabelValue label={t('status')} value={t(shipment.status)} />
                <LabelValue label={t('mailStatus')} value={t(shipment.mailStatus)} />
                <LabelValue label={t('lastMailDate')} value={formatDateTimeString(shipment.lastMailDate)} />
            </FormGrid>
        </Widget>
    );
};
